import { useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { PersonAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { TrainingRequestDetailFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface ApplicantProps {
  trainingRequest: TrainingRequestDetailFragment
}
export const ApplicantBlock = ({ trainingRequest }: ApplicantProps) => {
  const author = trainingRequest.author
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (!author) return <></>
  const employee = author.employee
  if (!employee) return <></>

  const onClick = () => {
    track(trackingEvents.training.trainingRequest.applicantDetail)
    const id = employee.id
    navigate(navigation.employees.id.fullPath({ id }))
  }

  return (
    <Box gap="s8">
      <Text size="200" color="grey1000" weight="medium">
        {i18n.t('trainings.training_requests.my_requests.datatable.columns.applicant')}
      </Text>
      <Box
        borderRadius={{ all: 'abs006' }}
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        padding="s24"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box flexDirection="row" gap="s24" alignItems="center">
          <PersonAvatar
            size="medium"
            firstName={employee.fullName}
            lastName={''}
            src={employee.avatar?.url}
          />
          <Text size="300" color="grey1000" weight="medium">
            {employee.fullName}
          </Text>
        </Box>
        <Button type="secondary" onClick={onClick} iconName="arrow-right" />
      </Box>
    </Box>
  )
}
